import { render, staticRenderFns } from "./ModalBed.vue?vue&type=template&id=86ad2d9a&scoped=true&"
import script from "./ModalBed.vue?vue&type=script&lang=js&"
export * from "./ModalBed.vue?vue&type=script&lang=js&"
import style0 from "./ModalBed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ad2d9a",
  null
  
)

export default component.exports